import { render, staticRenderFns } from "./MobileNavBar.vue?vue&type=template&id=896f81a6"
import script from "./MobileNavBar.vue?vue&type=script&lang=js"
export * from "./MobileNavBar.vue?vue&type=script&lang=js"
import style0 from "./MobileNavBar.vue?vue&type=style&index=0&id=896f81a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports